import * as ls from 'local-storage';

// Add item to local storage
export const addStorage = (key:string, value:any) => {
  try {
    ls.set(key, value);
  } catch (error) {
    console.error('Failed to add to storage', error);
  }
};

// Get item from local storage
export const getStorage = (key:any) => {
  try {
    const value = ls.get(key);
    return value;
  } catch (error) {
    return null;
  }
};

// Remove item from local storage
export const removeStorage = (key) => {
  try {
    ls.remove(key);
  } catch (error) {
    console.error('Failed to remove from storage', error);
  }
};
